import React from 'react';
import {
    LinkName,
    QuickHeaderButton,
} from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/quickHeader/QuickHeader.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { QuickHeaderSignUpIcon } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/quickHeader/SignUpIcons';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { GoogleTagManagerState } from 'src/domains/layouts/state/googleState/GoogleTagManagerState';

export const SignUpButtons = observer('SignUpButtons', () => {
    const common = useCommon();
    const starRouter = StarRouter.get(common);
    const googleTagManager = GoogleTagManagerState.get(common);

    const handleRedirectToSignUp = (): void => {
        starRouter.redirectToSignUp();
        googleTagManager.gtmSignUpWelcomePage();
    };

    return (
        <QuickHeaderButton
            data-test='account-navigation-signup-link'
            isActive={false}
            onClick={handleRedirectToSignUp}
        >
            <QuickHeaderSignUpIcon />

            <LinkName>
                <I18n
                    langKey='quick-header.sign-up.label'
                    defaultText='Sign Up'
                />
            </LinkName>
        </QuickHeaderButton>
    );
});
